import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetSpeakingResult } from '../models/speaking2.model';

const uri = '/home/speaking';

export const getSpeakingResult = (examTestCode: number): AxiosPromise<IGetSpeakingResult> => {
  return axios.get(`${uri}/${examTestCode}/result`);
}
